export default "__VITE_ASSET__CTrccSdx__"